module.exports = __webpack_public_path__ + "media/stop-15.84c1123d.mp3";